<template>
<div class="space-map-wrapper">
  <div ref="map-wrapper" class="space-map">
    <div class="space-map-inner"></div>
    <slot name="map-ele" />
  </div>

  <div class="space-map-toolbar">
    <slot name="toolbar" />
  </div>

  <slot />
</div>
</template>

<script>
import L from 'leaflet.chinesetmsproviders/lib/leaflet'

export default {
  name: 'SpaceMap',
  props: {
    center: {
      required: true,
      type: Array
    },
    defaultZoom: {
      required: true,
      type: Number
    },
    minZoom: {
      type: Number,
      default: 5
    },
    maxZoom: {
      type: Number,
      default: 18
    },
    boundaries: {
      type: Object
    },
    geoJson: {},
    geoJsonStyle: {},
    sites: {
      type: Array
    }
  },
  methods: {
    getMapWrapper (filename) {
      return this.$refs['map-wrapper']
    },
    fitView (viewRect) {
      this.map.fitBounds([
        [viewRect[1], viewRect[0]],
        [viewRect[3], viewRect[2]]
      ])
    },
    render () {
      const {geoJson, dataLayer} = this
      dataLayer.clearLayers()

      if (geoJson) {
        dataLayer.addData(geoJson)
      }
    },
    renderSites () {
      const {sites} = this

      if (!Array.isArray(sites) || sites.length === 0) {
        return
      }

      const {map} = this

      sites.forEach(site => {
        L.marker([site.lngLat[1], site.lngLat[0]], {
          icon: L.divIcon({
            html: `<span>${site.name}</span>`,
            className: 'map-site-marker'
          })
        }).addTo(map)
      })
    },
    init () {
      const map = this.map = L.map(this.$refs['map-wrapper'], {
        center: this.center,
        zoom: this.defaultZoom,
        layers: [L.layerGroup([L.tileLayer.chinaProvider('GaoDe.Normal.Map', {
          maxZoom: this.maxZoom,
          minZoom: this.minZoom
        })])],
        zoomControl: false
      })

      const {boundaries} = this

      if (boundaries) {
        L.geoJson(boundaries, {
          style: feature => ({
            color: '#4264fb',
            weight: 2,
            fillOpacity: 0
          })
        }).addTo(map)
      }

      this.dataLayer = L.geoJson(this.geoJson, {
        style: this.geoJsonStyle
      }).addTo(map)

      this.renderSites()
    }
  },
  watch: {
    geoJson () {
      this.render()
    },
    sites () {
      this.renderSites()
    }
  },
  mounted () {
    setTimeout(() => {
      this.init()
    }, 0)
  },
  beforeDestroy () {
    const {map} = this

    if (map) {
      map.remove()
    }
  }
}
</script>

<style lang="scss">
.space-map-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.space-map {
  width: 100%;
  height: 100%;
}

.space-map-inner {
  width: 100%;
  height: 100%;
}

.space-map-toolbar {
  position: absolute;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  top: .8em;
  left: 0;
  width: 100%;
  padding: .8em;
}

.leaflet-bottom.leaflet-right {
  display: none;
}

.map-site-marker {
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #606266;
  text-shadow: 1px 1px 1px rgba(255, 255, 255, .2);
  white-space: nowrap;
  opacity: .65;
}
</style>



// WEBPACK FOOTER //
// src/components/SpaceMap/index.vue